<template>
    <div class="reset-pwd">
        <header-comp></header-comp>
        <div class="reset-pwd-wrap">
            <img class="reset-pwd-img" src="@/assets/img/flypig.svg" alt="">
            <h1 v-if="$route.query.mode == 'reset' ">重設密碼</h1>
            <h1 v-else>設定密碼</h1>
            <div class="reset-pwd-basic-info">
                <div class="password">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            <span v-if="$route.query.mode == 'reset' ">新密碼</span>
                            <span v-else>密碼</span>
                        </div>
                        <span v-show="error.resetPwd.password" class="error-with-title">{{error.resetPwd.password}}</span>
                    </label>
                    <div class="input-arear">
                        <input ref="password" :class="{error: error.resetPwd.password}" type=password v-model="resetPwd.password" placeholder="需包含英文加上數字八位字元">
                        <div v-if="password.pwdShow" @click="togglePassword('pwd')" class="show-hide-pwd">
                            <span v-if="password.pwdVisible">
                                隱藏
                            </span>
                            <span v-else>
                                顯示
                            </span>
                        </div>
                    </div>
                </div>
                <div class="password-check">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            再次確認密碼
                        </div>
                        <span v-show="error.resetPwd.passwordCheck" class="error-with-title">{{error.resetPwd.passwordCheck}}</span>
                    </label>
                    <div class="input-arear">
                        <input  ref="passwordCheck" :class="{error: error.resetPwd.passwordCheck}" type=password v-model="resetPwd.passwordCheck" placeholder="再次確認密碼">
                        <div v-if="password.pwdCheckShow" @click="togglePassword('pwdCheck')" class="show-hide-pwd">
                            <span v-if="password.pwdCheckVisible">
                                隱藏
                            </span>
                            <span v-else>
                                顯示
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="$route.query.mode == 'reset' " class="default-button" @click="setResetPwd()">重設密碼</div>
            <div v-else class="default-button" @click="setPwd()">設定密碼</div>
        </div>
    </div>
</template>
<script>
import Header from '@/components/bussiness/header.vue';
import { mapGetters } from 'vuex'
import { 
    apiBizResetPwd,
    apiBizCheckVerified 
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            resetPwd: {
                password: null,
                passwordCheck: null,
                regCodeTicket: null
            },
            error: {
                resetPwd: {
                    password: null,
                    passwordCheck: null,
                }
            },
            password: {
                pwdShow: false,
                pwdVisible: false,
                pwdCheckShow: false,
                pwdCheckVisible: false,
            },
        }
    },
    mounted () {
        if(this.$route.query.account){
            this.resetPwd.regCodeTicket = this.$route.query.account
        }else{
            // this.$router.push({name: 'Home'})
        }
    },
    watch: {
        resetPwd: {
            handler: function (val) {
                //密碼判斷
                let isText = /^(?=.*\d)(?=.*[a-zA-Z]).{8,30}$/;
                if( val.password ){
                    this.password.pwdShow = true
                    if (!isText.test(val.password)) {
                        this.error.resetPwd.password = '需包含英文加上數字八位字元';
                    }else {
                        this.error.resetPwd.password = null;
                    }
                }else{
                    this.password.pwdShow = false
                    this.error.resetPwd.password = null;
                }
                //密碼確認
                if( val.passwordCheck ){
                    this.password.pwdCheckShow = true
                    if(val.passwordCheck == val.password){
                        this.error.resetPwd.passwordCheck = null;
                    }else{
                        this.error.resetPwd.passwordCheck = '需與填寫密碼相同';
                    }
                }else{
                    this.password.pwdCheckShow = false
                    this.error.resetPwd.passwordCheck = null;
                }
            },
            deep: true
        },
    },
    methods: {
        setResetPwd: function () {
            if(this.checkInput()){
                let password = this.resetPwd.password
                let regCodeTicket = this.resetPwd.regCodeTicket
                let data = {password, regCodeTicket}


                apiBizResetPwd(data)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.$router.push({name: 'bizUpdateSecrectSuccess', query: {mode: this.$route.query.mode}})
                    }else{
                        let alarm = {
                            status: true,
                            title: res.data.errorMsg,
                            description: null,
                            type: 'error'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                    }
                })
                .catch(err => {
                    console.log(err)
                    let alarm = {
                        status: true,
                        title: '系統發生未預期錯誤，請再試一次',
                        description: null,
                        type: 'error'
                    }
                    this.$store.dispatch('setAlarmStatus', alarm)
                })
            }
            
        },
        setPwd: function () {
            if(this.checkInput()){
                let password = this.resetPwd.password
                let verificationCode = this.resetPwd.regCodeTicket
                let data = {password, verificationCode}


                apiBizCheckVerified(data)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.$router.push({name: 'bizUpdateSecrectSuccess', query: {mode: this.$route.query.mode}})
                    }else{
                        let alarm = {
                            status: true,
                            title: res.data.errorMsg,
                            description: null,
                            type: 'error'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                    }
                })
                .catch(err => {
                    console.log(err)
                    let alarm = {
                        status: true,
                        title: '系統發生未預期錯誤，請再試一次',
                        description: null,
                        type: 'error'
                    }
                    this.$store.dispatch('setAlarmStatus', alarm)
                })
            }
            
        },
        checkInput: function () {
            if(!this.resetPwd.password){
                this.error.resetPwd.password = '請輸入密碼'
            }
            if(!this.resetPwd.passwordCheck){
                this.error.resetPwd.passwordCheck = '請輸入確認密碼'
            }
            if(
                this.resetPwd.password &&
                this.resetPwd.passwordCheck &&
                this.error.resetPwd.password == null &&
                this.error.resetPwd.passwordCheck == null
            ){
                return true
            }else{
                return false
            }
        },
        togglePassword: function (type) {
            if(type == 'pwd'){
                let password = this.$refs.password;
                if (password.type === "password") {
                    this.password.pwdVisible = true
                    password.type = "text";
                } else {
                    this.password.pwdVisible = false
                    password.type = "password";
                }
            }else{
                let password = this.$refs.passwordCheck;
                if (password.type === "password") {
                    this.password.pwdCheckVisible = true
                    password.type = "text";
                } else {
                    this.password.pwdCheckVisible = false
                    password.type = "password";
                }
            }
            
        },
    },
    components: {
        'header-comp': Header,
    }
}
</script>
<style lang="scss" scoped>
    .reset-pwd{
        position: relative;
        >.reset-pwd-wrap{
            width: 424px;
            padding-top: 105px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            label{
                .title{
                    display: flex;
                    align-items: center;
                    .must-fill{
                        position: relative;
                        top: 3px;
                        margin-right: 4px;
                        color: #fc7171;
                    }
                }
            }
            input{
                box-sizing: border-box;
                width: 424px;
            }
            .reset-pwd-img{
                width: 80px;
                margin-bottom: 20px;
            }
            h1{
                font-size: 24px;
                margin-bottom: 30px;
            }
            .reset-pwd-basic-info{
                width: 100%;
                >div{
                    margin-bottom: 24px;
                    .show-hide-pwd{
                        position: absolute;
                        font-size: 12px;
                        top: 16px;
                        right: 16px;
                        cursor: pointer;
                    }
                }
            }
            .default-button{
                margin-top: 6px;
                width: 100%;
                padding: 14px 0 14px 0;
                
            }
        }
    }
    @media screen and (max-width: 500px) {
        .reset-pwd{
            position: relative;
            >.reset-pwd-wrap{
                padding: 82px 4.8% 0 4.8%;
                width: 90.4%;
                input{
                    box-sizing: border-box;
                    width: 100%;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/registerFlow/setPassword.vue